(function () {
  "use strict";

  function cartAddUrl() {
    return (window.theme && theme.routes && theme.routes.cartAdd) || "/cart/add.js";
  }

  function addToCart(variantId, quantity) {
    return fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    }).then((r) => r.json());
  }

  function addToCartFromForm(form) {
    const formData = new FormData(form);
    return fetch(cartAddUrl(), {
      method: "POST",
      body: formData,
    }).then((r) => r.json());
  }

  function openCartAfterAdd(product) {
    document.dispatchEvent(
      new CustomEvent("ajaxProduct:added", { detail: product })
    );
  }

  window.theme = window.theme || {};
  theme.blueLightCart = {
    addToCart: addToCart,
    addToCartFromForm: addToCartFromForm,
    openCartAfterAdd: openCartAfterAdd,
  };
})();
